import { PluginKey } from 'prosemirror-state'

export const ALMANAC_DROP_CURSOR_PLUGIN_KEY = new PluginKey('AlmanacDropCursor')
